import { Dictionary } from '@ngrx/entity'
import { createFeatureSelector, createSelector } from '@ngrx/store'

import { CompetitionPool } from './competition-pool'
import * as fromCompetitionPool from './competition-pool.reducer'

const state = createFeatureSelector<fromCompetitionPool.CompetitionPoolState>(
  fromCompetitionPool.FEATURE_NAME
)

const adapter = fromCompetitionPool.adapter.getSelectors()

const selectIds = createSelector(state, adapter.selectIds)
const selectAll = createSelector(state, adapter.selectAll)
const selectEntities = createSelector(state, adapter.selectEntities)
const selectIsLoading = createSelector(state, (state) => state.isLoading)

const selectState = createSelector(state, (state) => state && state)

const selectById = createSelector(
  selectEntities,
  (entities: Dictionary<CompetitionPool>, id: number) => {
    return entities[id]
  }
)

const selectByFilter = createSelector(
  selectAll,
  (
    entities: CompetitionPool[],
    filter?: { field: string; value: string | number }
  ) => {
    if (filter) {
      return entities.filter((entity) => entity[filter.field] == filter.value)
    }

    return entities
  }
)

const selectCount = createSelector(
  selectAll,
  (entities) => entities && entities.length
)

const selectPaginationDetails = createSelector(
  state,
  (state) => state.paginationDetails
)

export const competitionPoolSelectors = {
  selectState,
  selectIsLoading,
  selectById,
  selectIds,
  selectEntities,
  selectAll,
  selectByFilter,
  selectCount,
  selectPaginationDetails
}
